<script lang="ts">
	import { defineComponent } from "vue";
	import BannerCampus from "../components/landing/BannerCampusSlider.vue";
    import FormarBloqueLanding from "../components/landing/FormarBloqueLanding.vue";
    import Oferta from "../components/landing/Oferta.vue";
    import Ubicacion from "../components/landing/Ubicacion.vue";
    import Instalaciones from "../components/landing/Instalaciones.vue";
    import Tour360 from "../components/landing/Tour360.vue";
	// import ModelosEducativos from "../components/landing/ModelosEducativos.vue";
	// import OfertaEducativa from "../components/landing/OfertaEducativa.vue";
	// import HumanitasMuchoMas from "@/components/HumanitasMuchoMas.vue";


	export default defineComponent({
		name: "CampusPresaMadin",
		components: {
			BannerCampus,
            FormarBloqueLanding,
            Oferta,
            Ubicacion,
            Instalaciones,
            Tour360
		},
		props: {
			campus: {
				type: String,
				required: true,
			},
			banner: {
				type: String,
				required: true,
			},
        },
        data() {
            return {
                currentImage: 0,
                currentImage2: 0,
                images: [
                    '/pagesImages/instalaciones-Merida-1.webp',
                    '/pagesImages/juicios-Merida-1.webp',
                    '/pagesImages/biblioteca-Merida-2.webp',
                    '/pagesImages/aula-Merida-1.webp',
                    '/pagesImages/gesell-Merida-1.webp',
                    //'/pagesImages/despierta-merch-2.webp',
                ],
                images2: [
                    '/pagesImages/auditorioa-Merida-1.webp',
                    '/pagesImages/cafeteria-Merida-1.webp',
                    '/pagesImages/auditorioa-Merida-2.webp',
                ],
                imagesArray: [
                    "/pagesImages/encabezado-Merida-1.webp",
                    "/pagesImages/encabezado-Merida-2.webp",
                    "/pagesImages/encabezado-Merida-3.webp",
                ],
                altArray: [
                    "Fotos de campus Magno Mérida",
                    "Fotos de campus Magno Mérida",
                    "Fotos de campus Magno Mérida",
                ],
                tour: [
                    { src:"/pagesImages/tour-Merida-1.webp", title:"Tour virtual en Campus Magno Mérida"},
                    { src:"/pagesImages/tour-Merida-2.webp", title:"Tour virtual en Campus Magno Mérida"},
                    { src:"/pagesImages/tour-Merida-3.webp", title:"Tour virtual en Campus Magno Mérida"},
                    { src:"/pagesImages/tour-Merida-4.webp", title:"Tour virtual en Campus Magno Mérida"},
                    { src:"/pagesImages/tour-Merida-5.webp", title:"Tour virtual en Campus Magno Mérida"},
                    { src:"/pagesImages/tour-Merida-7.webp", title:"Tour virtual en Campus Magno Mérida"},
                    { src:"/pagesImages/tour-Merida-9.webp", title:"Tour virtual en Campus Magno Mérida"},
                ],
                campusName: "MÉRIDA",
                campusType: "CAMPUS MAGNO",
                localidad: "Yucatán",
                frase: "Saber es poder",
                autor: "Sir Francis Bacon",
            }
        },
        methods: {
            nextImage() {
                this.currentImage = (this.currentImage + 1) % this.images.length
            },
            nextImage2() {
                this.currentImage2 = (this.currentImage2 + 1) % this.images2.length
            }
        }
	});
</script>

<template>
	<!-- <BannerCampus :banner="banner"/> -->
    <BannerCampus :campusType="campusType" :campus="campusName" :localidad="localidad" :slider="imagesArray" :alt="altArray" :frase="frase" :autor="autor" :banner="banner"/>
    <FormarBloqueLanding :frase="'Campus Magno Mérida'" :testo1="'Se consolida como una de las mejores opciones educativas del sureste de México, debido a su enfoque humanista, excelencia académica e instalaciones que elevan la experiencia formativa a otro nivel.'" :testo2="'Rodeado de naturaleza y diseñado para inspirar, este campus impulsa el pensamiento crítico, la reflexión profunda y el desarrollo de habilidades prácticas educativas que responden a las demandas laborales del presente.'" :img="'/pagesImages/una-mirada-Merida.webp'" :alt="'Panorámica de Campus Magno Mérida'" class="mb-16" />
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Instalaciones</h2>
            <p class="text-center mb-8">Este campus se enfoca en una formación que equilibra teoría y práctica, con un sello humanista y con valores, por lo que los egresados<br class="lg:block hidden"> son agentes de cambio listos para transformar sus entornos y afrontar los desafíos globales.</p>
            <div class="flex flex-col justify-between">
                <div class="lg:flex items-center justify-center mb-16">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Instalaciones especializadas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Áreas equipadas para disciplinas como Psicología y Derecho, con herramientas especializadas para el desarrollo práctico de los estudiantes.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Biblioteca y recursos digitales</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Con acceso a libros físicos, bases de datos digitales y computadoras, la biblioteca fomenta el estudio en un entorno cómodo y bien equipado.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Aulas interactivas</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Los salones cuentan con proyectores y sistemas de audio para clases dinámicas e interactivas.</p>
                        </div>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images[currentImage]"
                        alt="Instalaciones de Campus Magno Mérida"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-between">
                <div class="flex lg:flex-row flex-col items-center justify-center">
                    <div class="flex lg:order-1 order-2 items-center justify-center w-full lg:max-w-[520px] relative">
                        <img
                        :src="images2[currentImage2]"
                        alt="Instalaciones de Campus Magno Mérida"
                        class="w-full lg:max-w-[520px]"
                        />
                        <button
                        @click="nextImage2"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/50 text-black focus:outline-none px-4 p-2 rounded-full hover:bg-white/30 transition"
                        >
                        &gt;
                        </button>
                    </div>
                    <div class="lg:w-[50%] order-1 lg:order-2 text-justify mb-8 lg:mb-0 lg:ml-12 space-y-8">
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Auditorio</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">En este recinto se realizan eventos culturales, conferencias, encuentros multidisciplinarios, foros, debates y presentaciones.</p>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-lg text-left uppercase w-full">Cafetería</h3>
                            <p class="text-justify lg:hyphens-none hyphens-auto">Despierta es un concepto de cafeterías que fusiona una alimentación saludable con el sabor casero de una comida nutritiva.</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="grid lg:grid-cols-2 grid-cols-1 gap-10">
                
            </div> -->
        </div>
    </div>
    <h2 class="text-hgold text-center font-serif md:text-[42px] text-[32px] lg:px-0 px-8 mb-4 leading-none w-full">Oferta académica en<br class="lg:block hidden"> Campus Magno Mérida</h2>
    <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho'],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Psicoterapia con un<br> enfoque Psicoanalítico', 'Mercadotecnia', 'Justicia Penal', 'Contabilidad', 'Educación',],
    }" class="flex items-center justify-center" />
    <!-- <Oferta :virtual=false :visibleOffers="{
        Licenciaturas: ['Administración', 'Contabilidad', 'Psicología' , 'Derecho', 'Arquitectura', 'Diseño Gráfico'],
        Maestrías: ['Alta Dirección', 'Derecho Corporativo', 'Derecho Fiscal', 'Derecho Penal', 'Psicoterapia con un<br> enfoque Psicoanalítico', 'Mercadotecnia Digital', 'Justicia Penal', 'Contabilidad', 'Educación',],
    }" class="flex items-center justify-center" /> -->
    <section class="flex w-full items-center justify-center text-gray-700 mt-10">
        <div class="flex flex-col w-full max-w-[1200px] justify-center items-center">
            <div class="flex flex-col md:flex-row items-center justify-center mb-16 w-full max-w-4xl lg:max-w-[1200px]">
                <div class="order-2 md:order-1 flex w-full md:w-1/2 justify-center md:justify-end lg:px-0 px-8">
                    <img src="/pagesImages/landing-virtual-doctorado.webp" width="494" height="494" loading="lazy" class="w-auto h-auto" alt="Explora los diplomados">
                </div>
                <div class="order-1 md:order-2 flex flex-col lg:px-14 px-8 md:py-0 w-full md:w-1/2 items-center md:items-start">
                    <p class="text-center md:text-left line-height-36 text-4xl text-hgold mb-4 font-serif">Diplomados</p>
                    <ul class="text-left pl-6 space-y-1 list-disc">
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Tanatología</a>
                        </li>
                        <li class="">
                            <a href="https://humanitas.edu.mx/educacion-continua">Criminología</a>
                        </li>
                    </ul>
                    <br>
                </div>
            </div>
        </div>
    </section>
    <div class="flex items-center justify-center w-full mb-16 mt-6 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-16 leading-none w-full">Nuestros modelos educativos</h2>
            <section class="flex items-center justify-center mb-16 w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo ejecutivo</span>
                                </h3>
                                <p class=" lg:hyphens-none hyphens-auto">
                                    Está diseñado para brindar flexibilidad sin comprometer la calidad académica. Los programas se estructuran en bloques trimestrales, cada uno fusionando tres materias, impartidas por especialistas. Requiere autodisciplina, gestión eficiente del tiempo y compromiso con el éxito académico.
                                </p>
                            </div>
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/mujer-modelo-ejecutivo-universidad-humanitas.webp" alt="Modelo ejecutivo en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="flex items-center justify-center w-full">
                <div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
                    <div class="flex flex-col justify-between">
                        <div class="lg:flex items-center justify-center">
                            <div class="flex items-center justify-center w-full lg:max-w-[520px]">
                                <img src="/pagesImages/modelo-escolarizado-madin.webp" alt="Estudiante modelo escolarizado en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
                            </div>
                            <div class="lg:w-[50%] text-justify mt-8 lg:mt-0 lg:ml-12">
                                <h3>
                                    <!-- <span class="block text-[#73793B] leading-none text-left text-[28px]" style=""></span>
                                    <span class="sr-only whitespace-nowrap">&nbsp;</span> -->
                                    <span class="block text-hgold text-left font-serif mb-3 text-3xl md:text-4xl">Modelo escolarizado</span>
                                </h3>
                                <p class="lg:hyphens-none hyphens-auto">
                                    Ofrece una formación académica de calidad con un enfoque práctico y humano. Cada licenciatura está diseñada con objetividad e integrada con talleres y seminarios, que potencian la preparación para enfrentar los desafíos del mundo actual con conocimiento, habilidades y experiencia.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <div class="flex items-center justify-center w-full mb-16 relative">
        <div class="flex flex-col items-center justify-center w-full max-w-4xl lg:max-w-[1200px] lg:px-0 px-8">
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-8 leading-none w-full">Tour virtual</h2>
            <p class="mb-10">Conoce el Campus Magno Mérida en nuestro tour virtual.</p>
            <Tour360 :src="'https://tourmkr.com/F1v6rresFX/46693686p&311.83h&85.94t'"  class="w-full mb-12"/>
            <h2 class=" text-hgold text-center font-serif md:text-[42px] text-[32px] mb-10 leading-none w-full">Galería</h2>
            <Instalaciones :items="tour" class="" />
        </div>
    </div>
	<Ubicacion :campus="'Campus Magno Mérida'" :mapa="'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1107.3502055770193!2d-89.69275270458108!3d21.005970547636476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f567153d15c7715%3A0x5f3e61b5a89a4fac!2sUniversidad%20Humanitas%20Campus%20M%C3%A9rida!5e0!3m2!1ses-419!2smx!4v1692815838845!5m2!1ses-419!2smx'" :testo1="'El Campus está ubicado en la zona de Caucel, para llegar al lugar se debe utilizar el sistema de transporte Va-Y-Ven, en la ruta 91. En dado caso de arribar en automóvil, las principales vías de acceso son: Avenida 70 y calle 31.'" :ubicacion="'Calle 31 y 70, Fracc. Cd. Caucel, Mérida C.P. 97314, Yucatán.'" :telefono="'999-924-57-54'" class="lg:px-0 px-8" />
</template>

<style scoped>
</style>
